import React, { FC } from 'react';
import { composeClasses } from '../../../libs/utils/index';
import './SubmitButton.css';

export enum ButtonDisplay {
    FillAvailable = 'btn-block',
    FitContent = 'btn-inline',
    NextButton = 'btn',
    InvertedNext = 'btn-next-inverted',
    InvertedSuccess = 'btn-next-inverted-success',
    InvertedDanger = 'btn-next-inverted-danger',
    Danger = 'btn-next-danger',
    DangerRounded = 'btn-next-danger-rounded',
    Success = 'btn-next-success',
    SuccessRounded = 'btn-next-success-rounded',
    Dark = 'btn-dark',
    Blue = 'btn-blue',
    Transparent = 'btn-transparent',
    Primary = 'btn-primary',
    Secondary = 'btn-secondary',
    TableAction = 'btn-table-action',
    invoicing = 'btn'
}

interface IOpttyButton
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  text: string | React.ReactNode;
  textBold?: boolean;
  display?: ButtonDisplay;
  icon?: React.ReactNode;
}

const Button: FC<IOpttyButton> = ({
  display = ButtonDisplay.FitContent,
  textBold = true,
  type = 'button',
  ...props
}) => {
  /* eslint-disable react/button-has-type */
  return (
    <button
      className={composeClasses('button', display, textBold ? 'text-bolder' : '')}
      type={type}
      {...props}
    >
      {props.icon ? (
        <span className="btn-with-icon">
          <i className="icon">{props.icon}</i> <span className="text">{props.text}</span>
        </span>
      ) : (
        props.text
      )}
    </button>
  );
  /* eslint-enable react/button-has-type */
};

export default Button;
